module.exports = __webpack_public_path__ + "media/flags/my-d39816cd.svg";